import { Modal } from 'antd';
import React from 'react';

import MatchGameFilters from '../../../../../../components/MatchGameFilters/MatchGameFilters';
import { MatchGameFilterType } from '../../../../../../V2/model/interfaces/MatchGameFilterType';

interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
  onFilterSet: (e: any) => void;
}
export const SettingsModal = ({ open = true, onClose, onFilterSet }: SettingsModalProps) => {
  return (
    <Modal open={open} onCancel={onClose} footer={null}>
      <MatchGameFilters
        updateFilters={(filter: MatchGameFilterType) => {
          onFilterSet(filter);
          onClose();
        }}
      />
    </Modal>
  );
};
